export default [
  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/coming-soon",
    name: "misc-coming-soon",
    component: () => import("@/views/pages/miscellaneous/ComingSoon.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/not-authorized",
    name: "misc-not-authorized",
    component: () => import("@/views/pages/miscellaneous/NotAuthorized.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/under-maintenance",
    name: "misc-under-maintenance",
    component: () => import("@/views/pages/miscellaneous/UnderMaintenance.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/error",
    name: "misc-error",
    component: () => import("@/views/pages/miscellaneous/Error.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/payments/callback",
    name: "payments",
    component: () => import("@/views/pages/miscellaneous/ComingSoon.vue"),
    meta: {
      layout: "full",
      notNeedLogin: true,
    },
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () => import("@/views/pages/invoice/Invoice.vue"),
    meta: {
      contentClass: "ecommerce-application",
    },
  },
  {
    path: "/penalties",
    name: "penalties",
    component: () => import("@/views/pages/penalties/Penalties.vue"),
    meta: {
      hasPermission: true,
    },
  },
  {
    path: "/audit-logs",
    name: "audit-logs",
    component: () => import("@/views/pages/audit-logs/AuditLogs.vue"),
    meta: {
      hasPermission: true,
    },
  },
  {
    path: "/transactions",
    name: "transactions",
    component: () => import("@/views/pages/transactions/Transactions.vue"),
    meta: {
      hasPermission: true,
    },
  },
  {
    path: "/devices",
    name: "devices",
    component: () => import("@/views/pages/devices/Devices.vue"),
    meta: {
      hasPermission: true,
    },
  },
  {
    path: "/shop",
    name: "shop",
    component: () => import("@/views/pages/shop-list/ShopList.vue"),
    meta: {
      notNeedLogin: true,
    },
  },
  {
    path: "/email",
    name: "apps-email",
    component: () => import("@/views/pages/emails/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
    },
  },
  {
    path: "/email/:folder",
    name: "apps-email-folder",
    component: () => import("@/views/pages/emails/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
      navActiveLink: "apps-email",
    },
    // beforeEnter(to, _, next) {
    //   if (
    //     ["sent", "draft", "starred", "spam", "trash"].includes(to.params.folder)
    //   )
    //     next();
    //   else next({ name: "error-404" });
    // },
  },
  {
    path: "/email/:filters",
    name: "apps-email-label",
    component: () => import("@/views/pages/emails/Email.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
      navActiveLink: "apps-email",
    },
    // beforeEnter(to, _, next) {
    //   if (
    //     ["personal", "company", "important", "private"].includes(
    //       to.params.label
    //     )
    //   )
    //     next();
    //   else next({ name: "error-404" });
    // },
  },
];
